import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExperienceComponent } from './experience.component';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'primeng/carousel';
import { TabViewModule } from 'primeng/tabview';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { ExperienceCardComponent } from './experience-card/experience-card.component';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { ExperienceMapComponent } from './experience-map/experience-map.component';
import { ExperienceMapV2Component } from './experience-map-v2/experience-map-v2.component';
import { PeopleDropdownComponent } from '../../pages/experience/people-dropdown/people-dropdown.component';
import { ExtraDropdownComponent } from "../../extra-dropdown/extra-dropdown.component";
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { RegionCardComponent } from '../territory/region-card/region-card.component';
import { WineRegionCardComponent } from '../territory/wine-region-card/wine-region-card.component';
import { WineryCardComponent } from '../winery-card/winery-card.component';
import { CarouselDragDirective } from '../../directives/carousel-drag.directive';
import { ImageFallbackDirective } from '../../directives/image-fallback.directive';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ExperienceComponent, ExperienceCardComponent, ExperienceMapComponent, ExperienceMapV2Component,RegionCardComponent,WineRegionCardComponent,WineryCardComponent],
    exports: [ExperienceComponent, ExperienceCardComponent,RegionCardComponent, ExperienceMapComponent, ExperienceMapV2Component,WineRegionCardComponent,WineryCardComponent],
    imports: [
        CommonModule,
        RouterModule,
        CarouselModule,
        TabViewModule,
        CardModule,
        FormsModule,
        CalendarModule,
        DropdownModule,
        SkeletonModule,
        ImageFallbackDirective,
        PeopleDropdownComponent,
        ExtraDropdownComponent,
        ToastModule,
        CarouselDragDirective,
        TranslateModule
    ],
    providers: [MessageService],
})
export class ExperienceModule { }